export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";